import { FlexTemplateRendererComponentLibrary } from 'flex-template-renderer-react';

import { AboutThisPropertyWrapper } from './about-property-wrapper';
import { ActivityRecommendationsWrapper } from 'components/infosite/activity-recommendations';
import { IntersectionTrackerWrapper } from './intersection-wrapper';
import { LayoutGrid } from './layout-grid';
import { LayoutGridItem } from './layout-grid-item';
import { PropertyGallery } from 'components/infosite/property-details/property-gallery';
import { PropertyLevelMessages } from './property-messages';
import { PropertyNavigation } from './property-navigation';
import { SharedUiAmenityDescriptionWrapper } from 'components/infosite/shared-ui/details/amenity-description-wrapper';
import { SharedUiImportantInfoWrapper } from 'components/infosite/shared-ui/details/important-info-wrapper';
import { SharedUiPoliciesWrapper } from 'components/infosite/shared-ui/details/policies-wrapper';
import { SharedUiPropertyReviewsWrapper } from 'components/infosite/shared-ui/reviews/shared-ui-property-reviews-wrapper';
import { SharedUiSimilarPropertiesWrapper } from 'components/infosite/shared-ui/shared-ui-similar-properties';
import { SharedUiWhatsAroundWrapper } from 'components/infosite/shared-ui/details/whats-around-wrapper';
import { SimilarHotelsWrapper } from './meso-carousel-wrapper';
import { SingleOfferPriceWrapper } from './single-offer-price';
import { SingleOfferSummaryWrapper } from './property-summary-wrapper';
import { SpaceDetailsWrapper } from './space-details-wrapper';
import { StickyBookBar } from './sticky-book-bar';

export const componentLibrary: FlexTemplateRendererComponentLibrary = new Map()
  .set('LayoutGrid', LayoutGrid)
  .set('SpaceDetailsWrapper', SpaceDetailsWrapper)
  .set('AboutThisPropertyWrapper', AboutThisPropertyWrapper)
  .set('SharedUiAmenityDescriptionWrapper', SharedUiAmenityDescriptionWrapper)
  .set('SharedUiImportantInfoWrapper', SharedUiImportantInfoWrapper)
  .set('SharedUiPoliciesWrapper', SharedUiPoliciesWrapper)
  .set('SharedUiPropertyReviewsWrapper', SharedUiPropertyReviewsWrapper)
  .set('IntersectionTrackerWrapper', IntersectionTrackerWrapper)
  .set('SingleOfferSummaryWrapper', SingleOfferSummaryWrapper)
  .set('SharedUiWhatsAroundWrapper', SharedUiWhatsAroundWrapper)
  .set('SharedUiPropertyLevelOffersMessageWrapper', PropertyLevelMessages)
  .set('SharedUiSimilarPropertiesWrapper', SharedUiSimilarPropertiesWrapper)
  .set('SimilarHotelsMesoWrapper', SimilarHotelsWrapper)
  .set('SharedUiStickyBookBarWrapper', StickyBookBar)
  .set('ActivityRecommendationsWrapper', ActivityRecommendationsWrapper)
  .set('SingleOfferPriceWrapper', SingleOfferPriceWrapper)
  .set('PropertyGallery', PropertyGallery)
  .set('PropertyNavigation', PropertyNavigation)
  .set('LayoutGridItem', LayoutGridItem);
